import { render, staticRenderFns } from "./itemStockItemsTable.vue?vue&type=template&id=7c7bc548&"
import script from "./itemStockItemsTable.vue?vue&type=script&lang=ts&"
export * from "./itemStockItemsTable.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports